/**
 * Pagination data-hook props used for testing.
 */
/**
 * Pagination data-hook props used for testing.
 */
export var PaginationDataHooks;
(function (PaginationDataHooks) {
    PaginationDataHooks["currentPage"] = "current-page";
    PaginationDataHooks["totalPages"] = "total-pages";
    PaginationDataHooks["slashLabel"] = "slash-label";
    PaginationDataHooks["pageCompact"] = "page-compact";
    PaginationDataHooks["pageForm"] = "page-form";
    PaginationDataHooks["pageStrip"] = "page-strip";
    PaginationDataHooks["pageInput"] = "page-input";
    PaginationDataHooks["previous"] = "previous";
    PaginationDataHooks["next"] = "next";
    PaginationDataHooks["first"] = "first";
    PaginationDataHooks["last"] = "last";
    PaginationDataHooks["page"] = "page";
})(PaginationDataHooks || (PaginationDataHooks = {}));
//# sourceMappingURL=DataHooks.js.map